import * as React from "react";

import css from "./Breadcrumbs.module.scss";

export default function Breadcrumbs({
  items,
  className,
}: {
  items: { id: string; name: string; href?: string }[];
  className?: string;
}) {
  React.useEffect(() => {
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@id": item.id,
          name: item.name,
        },
      })),
    };

    const script = document.createElement("script");
    script.textContent = JSON.stringify(jsonLd);
    script.async = true;
    script.type = "application/ld+json";

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [items]);

  return (
    <nav aria-label="breadcrumbs" className={className}>
      <ol>
        {items.map((item, index) => (
          <li key={index} className={css.separator}>
            {item.href ? (
              <a href={item.href} className={css.crumbLink}>
                {item.name}
              </a>
            ) : (
              <span className={css.crumb}>{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
